export default "__VITE_ASSET__CqNEn3uu__"